import * as Sentry from "@sentry/react";
import "flag-icons/css/flag-icons.min.css";
import { createRoot } from "react-dom/client";
import "shared/falcon/helpers/initFA";
import App from "./App";
import "./shared/welda/features/content/i18n";

if (process.env.REACT_APP_ENABLE_SENTRY === "true" || false) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    environment: process.env.REACT_APP_ENV || "development",
    integrations: [
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: "system",
        isEmailRequired: false,
        isNameRequired: false,
        showEmail: false,
        includeReplay: false,
        triggerLabel: "Feedback",
        triggerAriaLabel: "Feedback",
        formTitle: "Feedback",
        submitButtonLabel: "Verstuur feedback",
        cancelButtonLabel: "Annuleren",
        confirmButtonLabel: "Bevestigen",
        addScreenshotButtonLabel: "Voeg een screenshot toe",
        removeScreenshotButtonLabel: "Verwijder screenshot",
        nameLabel: "Naam",
        namePlaceholder: "Je Naam",
        emailLabel: "E-mail",
        emailPlaceholder: "je.email@voorbeeld.org",
        isRequiredLabel: "(verplicht)",
        messageLabel: "Beschrijving",
        messagePlaceholder: "Wat is het probleem? Wat verwacht je? Suggesties?",
        successMessageText: "Bedankt voor je feedback!",
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
const root = createRoot(document.getElementById("main"));
root.render(<App />);

// submitButtonLabel	"Send Bug Report"	The label of the submit button used in the feedback form.
// cancelButtonLabel	"Cancel"	The label of cancel buttons used in the feedback form.
// confirmButtonLabel	"Confirm"	The label of confirm buttons used in the feedback form.
// addScreenshotButtonLabel	"Add a screenshot"	The label of the button to add a screenshot to the form.
// removeScreenshotButtonLabel	"Remove screenshot"	The label of the button to remove the screenshot from the form.
// nameLabel	"Name"	The label of the name input field.
// namePlaceholder	"Your Name"	The placeholder for the name input field.
// emailLabel	"Email"	The label of the email input field.
// emailPlaceholder	"your.email@example.org"	The placeholder for the email input field.
// isRequiredLabel	"(required)"	The label shown next to an input field that is required.
// messageLabel	"Description"	The label for the feedback description input field.
// messagePlaceholder	"What's the bug? What did you expect?"	The placeholder for the feedback description input field.
// successMessageText	"Thank you for your report!"	The message displayed after a successful feedback submission.
